import React, { useState, useEffect } from "react";
import { ReactComponent as Generalinfo } from "../../../Assets/Image/svg/Danger Circle.svg";
import { ReactComponent as Calculation } from "../../../Assets/Image/svg/Calculation-Icon.svg";
import { ReactComponent as Ticket } from "../../../Assets/Image/svg/Ticket 1.svg";
import { ReactComponent as Discount } from "../../../Assets/Image/svg/Discount Circle.svg";
import { ReactComponent as Unlock } from "../../../Assets/Image/svg/Unlock 1.svg";
import { ReactComponent as Support } from "../../../Assets/Image/svg/supoort.svg";
import { ReactComponent as FAQ } from "../../../Assets/Image/svg/FAQ Circle.svg";
import { ReactComponent as Education } from "../../../Assets/Image/svg/Session-Icon.svg";
import { ReactComponent as Inovice } from "../../../Assets/Image/svg/Inovice-Icon.svg";
import CourseGeneralInfo from "./info/CourseGeneralInfo";
import Phase from "../../share/phase/phase";
import Sessions from "./sessions/Sessions";
import CreateCourseTicket from "./ticket/CreateCourseTicket";
import CreateCourseDiscount from "./discount/CreateCourseDiscount";
import CreateCourseAccessibility from "./accessibility/CreateCourseAccessibility";
import CreateCourseSupporters from "./supporters/CreateCourseSupporters";
import CreateCourseQA from "./qa/CreateCourseQA";
import CreateCourseCalculator from "./calculator/CreateCourseCalculator";
import CreateCourseInovice from "./inovice/CreateCourseInovice";

const CreateCoursePhases = () => {
    const [PhaseNum, setPhaseNum] = useState(1);

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [PhaseNum]);

    const PhaseList = [
        {
            PhaseNumber: 1,
            phaseName: "اطلاعات کلی",
            phaseicon: <Generalinfo />,
        },
        {
            PhaseNumber: 2,
            phaseName: "جلسات",
            phaseicon: <Education />,
        },
        {
            PhaseNumber: 3,
            phaseName: "بلیت",
            phaseicon: <Ticket />,
        },
        {
            PhaseNumber: 4,
            phaseName: " تخفیف‌ها ",
            phaseicon: <Discount />,
        },
        {
            PhaseNumber: 5,
            phaseName: "مدیریت نقش",
            phaseicon: <Unlock />,
        },
        {
            PhaseNumber: 6,
            phaseName: "افراد",
            phaseicon: <Support />,
        },
        {
            PhaseNumber: 7,
            phaseName: "سوالات متداول",
            phaseicon: <FAQ />,
        },
        {
            PhaseNumber: 8,
            phaseName: "محاسبه‌گر ",
            phaseicon: <Calculation />,
        },
        {
            PhaseNumber: 9,
            phaseName: "فاکتور و پرداخت",
            phaseicon: <Inovice />,
        },
    ];
    const nextStep = () => {
        setPhaseNum((prevState) => prevState + 1);
    };
    const prevStep = () => {
        setPhaseNum((prevState) => prevState - 1);
    };

    //TODO : empty course dash dar hameye marahel fix she

    const changeContentsForm = () => {
        switch (PhaseNum) {
            case 1:
                return <CourseGeneralInfo nextStep={nextStep} />;
            case 2:
                return <Sessions nextStep={nextStep} prevStep={prevStep} />;
            case 3:
                return (
                    <CreateCourseTicket
                        nextStep={nextStep}
                        prevStep={prevStep}
                    />
                );
            case 4:
                return (
                    <CreateCourseDiscount
                        nextStep={nextStep}
                        prevStep={prevStep}
                    />
                );
            case 5:
                return (
                    <CreateCourseAccessibility
                        nextStep={nextStep}
                        prevStep={prevStep}
                    />
                );
            case 6:
                return (
                    <CreateCourseSupporters
                        nextStep={nextStep}
                        prevStep={prevStep}
                    />
                );
            case 7:
                return (
                    <CreateCourseQA nextStep={nextStep} prevStep={prevStep} />
                );
            case 8:
                return (
                    <CreateCourseCalculator
                        nextStep={nextStep}
                        prevStep={prevStep}
                    />
                );
            case 9:
                return (
                    <CreateCourseInovice
                        nextStep={nextStep}
                        prevStep={prevStep}
                    />
                );

            default:
                break;
        }
    };
    return (
        <div className="container">
            <Phase
                PhaseNum={PhaseNum}
                PhaseList={PhaseList}
                jump={setPhaseNum}
            />
            {changeContentsForm()}
        </div>
    );
};

export default CreateCoursePhases;
